export default __webpack_public_path__ + "f2c94e43bac9ef0f6f89ba3da4bbab73.svg";